<script>
  import Button from '@components/buttons/button.svelte'
  import { Trash2 } from 'lucide-svelte'
  
  let { text = "Supprimer", ...props } = $props()
</script>

<Button type="button" class="button outline-danger" Icon={Trash2} {text} {...props} />